import { z } from 'zod';

import { NotificationChannelSchema } from './enums';

// ============================================================================
// Templates — POST/GET/PUT/DELETE /api/v1/templates
// ============================================================================

export const CreateTemplateRequestSchema = z.object({
  id: z.string().min(1).max(100),
  name: z.string().min(1).max(100),
  channel: NotificationChannelSchema,
  subject: z.string().max(255).optional(),
  body: z.string().min(1),
  description: z.string().max(500).optional(),
});

export type CreateTemplateRequest = z.infer<typeof CreateTemplateRequestSchema>;

export const UpdateTemplateRequestSchema = CreateTemplateRequestSchema.omit({ id: true }).partial();

export type UpdateTemplateRequest = z.infer<typeof UpdateTemplateRequestSchema>;

export const TemplateResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  channel: NotificationChannelSchema,
  subject: z.string().nullable(),
  body: z.string(),
  description: z.string().nullable(),
  isActive: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type TemplateResponse = z.infer<typeof TemplateResponseSchema>;

export const ListTemplatesResponseSchema = z.array(TemplateResponseSchema);

export type ListTemplatesResponse = z.infer<typeof ListTemplatesResponseSchema>;


// ============================================================================
// MJML preview — notification-service `/templates/preview/*`
// ============================================================================
//
// Development-only endpoints (they answer 403 outside dev), but they were still
// bound to inline object types, so `{}` reached the compiler with `mjml`
// undefined and threw `Cannot read properties of undefined (reading 'tagName')`
// from inside the MJML library — surfaced as a 500.
//
// `mjml` is required and non-empty; nothing here validates that it is WELL-FORMED
// MJML, because that is exactly what these endpoints exist to tell you. Malformed
// input is a 400 with the compiler's own message, not a schema rejection.

export const CompileRawMjmlSchema = z.object({
  mjml: z.string().min(1),
  data: z.record(z.unknown()).optional(),
});
export type CompileRawMjmlRequest = z.infer<typeof CompileRawMjmlSchema>;

export const ValidateMjmlSchema = z.object({
  mjml: z.string().min(1),
});
export type ValidateMjmlRequest = z.infer<typeof ValidateMjmlSchema>;
